<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="9.434" height="4.585" viewBox="0 0 9.434 4.585">
        <path 
        class="a" 
        fill="#c3c3c2"
        stroke="rgba(0,0,0,0)"
        stroke-miterlimit="10"
        d="M-8611.786,5.585a.2.2,0,0,1-.13-.041l-4.046-3.356a.1.1,0,0,1-.039-.074c0-.055.063-.115.167-.115h1.194l2.724,2.26a.2.2,0,0,0,.13.041.2.2,0,0,0,.127-.041l2.725-2.26h1.194a.162.162,0,0,1,.161.087.09.09,0,0,1-.034.1l-4.046,3.356A.2.2,0,0,1-8611.786,5.585Z" transform="translate(8616.501 -1.5)"/>
    </svg>
</template>

<script>
export default {
  name: 'SortArrowDown'
}
</script>

<style scoped>
    svg {
        width: 9.434px;
        height: 4.585px;
    }
</style>